module.exports = __webpack_public_path__ + "market/static/img/faiImgNew.2593caa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/faiImgNew.png
// module id = noXI
// module chunks = 1